// import { FiPhone } from "react-icons/fi";
// import { MdOutlineMailOutline } from "react-icons/md";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import IconUI from './icon_ui'

function Footer() {
  return (
    <div className="bg-footer">
      <div className="container py-5">
        <div className="d-flex text-white" style={{ borderBottom: '1px solid gray' }}>
          <div className="text-big">La Verdad Minera</div>
     
        </div>
        <div className='text-white text-center py-3'>Todos los derechos reservados. © 2025 La Verdad Minera</div>
      </div>
    </div>
  )
}

export default Footer